import { useState, useRef, useCallback, useEffect } from "react";
import { saveSession, getGroqKey, saveGroqKey } from "../History";

// ── Data ─────────────────────────────────────────────────────────────────────

const TOP_UNIVERSITIES = [
  "Aalborg University",
  "Aalto University",
  "Abdelmalek Essaâdi University",
  "Ahmadu Bello University",
  "Al-Farabi Kazakh National University",
  "American University of Beirut",
  "American University of Nigeria",
  "Ashesi University",
  "Australian National University (ANU)",
  "Babcock University",
  "Bilkent University",
  "Boston University",
  "California Institute of Technology (Caltech)",
  "Carnegie Mellon University",
  "Charles University",
  "Chinese University of Hong Kong (CUHK)",
  "Chulalongkorn University",
  "Columbia University",
  "Concordia University",
  "Cornell University",
  "Covenant University",
  "Dalhousie University",
  "Delft University of Technology",
  "Duke University",
  "Durham University",
  "Ecole Polytechnique Fédérale de Lausanne (EPFL)",
  "Erasmus University Rotterdam",
  "ETH Zurich",
  "Fudan University",
  "Georgia Institute of Technology",
  "Harvard University",
  "HEC Paris",
  "Heidelberg University",
  "Humboldt University of Berlin",
  "Imperial College London",
  "Indian Institute of Technology Delhi (IITD)",
  "INSEAD",
  "Istanbul Technical University",
  "Jagiellonian University",
  "Johns Hopkins University",
  "KAIST (Korea Advanced Institute of Science and Technology)",
  "Karolinska Institute",
  "Khalifa University",
  "King Abdullah University of Science and Technology (KAUST)",
  "King Fahd University of Petroleum and Minerals (KFUPM)",
  "King's College London",
  "Koç University",
  "Kuwait University",
  "Kyoto University",
  "Lagos State University",
  "London School of Economics (LSE)",
  "Lomonosov Moscow State University",
  "Ludwig Maximilian University of Munich",
  "Lund University",
  "Makerere University",
  "Massachusetts Institute of Technology (MIT)",
  "McGill University",
  "McMaster University",
  "Middle East Technical University (METU)",
  "Monash University",
  "Nanyang Technological University (NTU)",
  "National University of Singapore (NUS)",
  "New York University (NYU)",
  "Northwestern University",
  "Obafemi Awolowo University",
  "Olabisi Onabanjo University",
  "Pan African University",
  "Pan-Atlantic University",
  "Peking University",
  "Pennsylvania State University",
  "Politecnico di Milano",
  "Pontificia Universidad Católica de Chile",
  "Princeton University",
  "Purdue University",
  "Qatar University",
  "Rice University",
  "RWTH Aachen University",
  "Sciences Po Paris",
  "Seoul National University",
  "Singapore Management University (SMU)",
  "Sorbonne University",
  "Stanford University",
  "Technical University of Munich (TUM)",
  "Tecnológico de Monterrey",
  "Texas A&M University",
  "Tsinghua University",
  "UCL (University College London)",
  "United Arab Emirates University",
  "Universidad Nacional Autónoma de México (UNAM)",
  "Universidad de Buenos Aires",
  "Universidad de los Andes",
  "Universidade Estadual de Campinas (Unicamp)",
  "Universidade de São Paulo",
  "Universitat de Barcelona",
  "University of Amsterdam",
  "University of Benin",
  "University of British Columbia",
  "University of California, Berkeley",
  "University of California, Los Angeles (UCLA)",
  "University of Cambridge",
  "University of Cape Town",
  "University of Chicago",
  "University of Copenhagen",
  "University of Edinburgh",
  "University of Ghana",
  "University of Hong Kong (HKU)",
  "University of Ibadan",
  "University of Illinois Urbana-Champaign",
  "University of Johannesburg",
  "University of Lagos",
  "University of Manchester",
  "University of Melbourne",
  "University of Michigan",
  "University of Nairobi",
  "University of New South Wales (UNSW Sydney)",
  "University of Nigeria, Nsukka",
  "University of Oslo",
  "University of Oxford",
  "University of Pennsylvania",
  "University of Queensland",
  "University of Southern California (USC)",
  "University of Sydney",
  "University of Tartu",
  "University of Tokyo",
  "University of Toronto",
  "University of Warwick",
  "University of Warsaw",
  "University of Washington",
  "University of Waterloo",
  "University of Witwatersrand",
  "University of Zurich",
  "Vanderbilt University",
  "Wageningen University & Research",
  "Waseda University",
  "Yale University",
  "Yonsei University",
  "Other (type below)"
];

const TOP_SCHOLARSHIPS = [
  "ADB-Japan Scholarship Program",
  "African Union Scholarship",
  "Aga Khan Foundation Scholarship",
  "Amsterdam Merit Scholarship (AMS)",
  "Australia Awards Scholarship",
  "Banting Postdoctoral Fellowships",
  "Benjamin A. Gilman International Scholarship",
  "Boren Awards & Fellowships",
  "British Council Scholarships for Women in STEM",
  "Chevening Scholarship",
  "Chinese Government Scholarship (CSC)",
  "Clarendon Fund Scholarships (Oxford)",
  "Commonwealth Scholarship",
  "DAAD Scholarship",
  "Dean’s Merit Scholarship (In-School)",
  "Departmental Scholarship",
  "Eiffel Excellence Scholarship Program",
  "Erasmus Mundus Scholarship",
  "ETH Zurich Excellence Scholarship",
  "Ford Foundation Fellowship",
  "Fulbright Scholarship",
  "Gates Cambridge Scholarship",
  "Graduate Assistantship (GA)",
  "Graduate Research Assistantship (GRA)",
  "GREAT Scholarships",
  "Heidrick & Struggles Leadership Scholarship",
  "Hong Kong PhD Fellowship Scheme",
  "Hubert Humphrey Fellowship",
  "Internal University Scholarship",
  "Joint Japan/World Bank Graduate Scholarship",
  "King Abdullah University of Science and Technology (KAUST) Scholarship",
  "Knight-Hennessy Scholars (Stanford)",
  "Korean Government Scholarship (KGSP)",
  "MasterCard Foundation Scholarship",
  "MEXT Scholarship (Japan)",
  "New Zealand Aid Scholarship",
  "NL Scholarship (Netherlands)",
  "OFID Scholarship",
  "Orange Knowledge Programme",
  "Pan African University Scholarship",
  "Provost’s Graduate Assistantship",
  "PTDF Scholarship (Nigeria)",
  "QuestBridge National College Match",
  "Research Assistantship (RA)",
  "Rhodes Scholarship",
  "Rotary Foundation Scholarship",
  "Saïd Foundation Scholarship",
  "Schwarzman Scholars",
  "Singapore International Graduate Award (SINGA)",
  "Soros Fellowship",
  "Stipendium Hungaricum Scholarship",
  "Swedish Institute Scholarship",
  "Swiss Government Excellence Scholarships",
  "Tata Scholarship",
  "Teaching Assistantship (TA)",
  "Turkish Government Scholarship (Türkiye Burslari)",
  "University Composition Fee Waiver",
  "UNU-WIDER Visiting PhD Fellowship",
  "Vanier Canada Graduate Scholarship",
  "VLIR-UOS Scholarship (Belgium)",
  "Weidenfeld-Hoffmann Scholarships",
  "Yenching Academy Scholarship",
  "Other (type below)"
];

const FIELDS = [
  "Aerospace Engineering",
  "Agriculture",
  "Anthropology",
  "Architecture",
  "Artificial Intelligence",
  "Arts & Humanities",
  "Aviation & Aerospace",
  "Bioinformatics",
  "Biological Sciences",
  "Biomedical Engineering",
  "Biotechnology",
  "Business / MBA",
  "Chemical Engineering",
  "Chemistry",
  "Civil Engineering",
  "Computer Engineering",
  "Computer Science",
  "Criminology",
  "Cyber Security",
  "Data Science",
  "Design",
  "Economics",
  "Education",
  "Electrical & Electronics Engineering",
  "Environmental Engineering",
  "Environmental Science",
  "FinTech",
  "Geology & Earth Sciences",
  "History",
  "Hospitality & Tourism Management",
  "Industrial Engineering",
  "International Relations",
  "Law",
  "Linguistics",
  "Marine Biology",
  "Materials Science & Engineering",
  "Mathematics & Statistics",
  "Mechanical Engineering",
  "Mechatronics",
  "Media & Communications",
  "Medicine / Public Health",
  "Nanotechnology",
  "Nursing",
  "Performing Arts",
  "Petroleum Engineering",
  "Pharmacy",
  "Philosophy",
  "Physics",
  "Political Science",
  "Psychology",
  "Quantum Computing",
  "Renewable Energy Engineering",
  "Robotics & Automation",
  "Social Sciences",
  "Sociology",
  "Software Engineering",
  "Sports Science",
  "Systems Engineering",
  "Urban Planning",
  "Veterinary Medicine",
  "Other"
];

const MODES = [
  {
    id: "review",
    label: "Review",
    icon: "🔍",
    desc: "Paste your existing SOP for a strict, honest committee-level review with scores.",
  },
  {
    id: "build",
    label: "Build",
    icon: "🏗",
    desc: "Answer guided questions and get a fully tailored SOP written for your specific purpose.",
  },
  {
    id: "scratch",
    label: "From Scratch",
    icon: "✍️",
    desc: "Start with nothing. We ask the right questions and write your SOP from the ground up.",
  },
];

const PURPOSE_TYPES = [
  { id: "scholarship", label: "Scholarship only" },
  { id: "admission", label: "University admission only" },
  { id: "both", label: "Both (scholarship + admission)" },
  { id: "postgrad", label: "Postgraduate research" },
];

// ── AI prompts ────────────────────────────────────────────────────────────────

const REVIEW_PROMPT = (sop, context) => `You are a senior member of a highly competitive scholarship and university admissions committee. You have reviewed thousands of statements of purpose. You are honest, exacting, and deeply experienced. You do not sugarcoat.

CONTEXT:
Purpose: ${context.purpose}
${context.university ? `University: ${context.university}` : ""}
${context.scholarship ? `Scholarship: ${context.scholarship}` : ""}
${context.field ? `Field: ${context.field}` : ""}

REVIEW THIS SOP:
"""
${sop}
"""

Your task: Produce a comprehensive, honest committee-level review. Be direct. Quote the actual text when praising or criticising. Treat this as if the applicant's future depends on your honesty — because it does.

STRICT WRITING RULES FOR YOUR REVIEW:
- No hyphens anywhere
- No AI language ("delve", "leverage", "it is worth noting", "in conclusion")
- No robotic grammar
- Write like a senior professor giving feedback after hours

Respond ONLY in this exact JSON format:
{
  "overallScore": 72,
  "overallVerdict": "2-3 sentence honest panel verdict on this SOP's competitiveness",
  "recommendation": "Strong Recommend / Recommend / Borderline / Do Not Recommend",
  "sections": [
    {
      "name": "Opening Hook",
      "score": 65,
      "feedback": "Detailed honest feedback quoting the actual text. What works, what fails, why.",
      "quote": "exact phrase from the SOP being commented on",
      "suggestion": "Concrete rewrite suggestion or direction"
    }
  ],
  "strengths": ["specific strength 1", "specific strength 2"],
  "critical_weaknesses": ["specific weakness 1", "specific weakness 2"],
  "red_flags": ["anything that would make a committee reject this immediately"],
  "rewrite_priorities": ["most important thing to fix first", "second most important"]
}

Score every section you find. Standard sections to look for and score: Opening Hook, Academic Background, Motivation & Purpose, Research/Career Goals, Why This School/Scholarship, Relevant Experience, Personal Story/Uniqueness, Writing Quality & Voice, Fit & Alignment, Closing.
If a section is missing, score it 0 and note it is absent.`;

// Shared SOP prompt engine
const SOP_RULES = `You write first-person Statements of Purpose. Direct, grounded, specific. No filler. No AI language.

GOLD STANDARD — this SOP scored 82/100. Study the voice, rhythm, and specificity. Every SOP you write must reach or exceed this standard:

"[The applicant] grew up watching hospitals in [their country] struggle with something that should not be a struggle. Not enough nurses to monitor every patient. Not enough time for doctors to catch every early warning sign. A patient in pain who cannot speak clearly enough to say so. [They] did not study [their field] because it was a safe career. [They] studied it because [they] believed it was one of the most direct ways to change that picture. The [programme] at [university] is the next step in making that belief into something real.

[They] graduated in [month year] with a [grade] in [field] from [institution], finishing with a [CGPA] and placing in the top [X]% of [their] graduating class. Following graduation, [they] joined [organisation] as a [role], achieving [result] across all modules in [their] first semester. [They] have built and documented several complete systems including a PID-controlled self-balancing robot, a four-degree-of-freedom assistive robotic arm, a fully fabricated automated bottling system, and a fixed-wing drone built from scratch with [their] team.

The project [they are] most invested in is [their current project], currently in active development. The system monitors patients remotely by reading [specific sensors] simultaneously to detect [specific outputs] without any physical contact. The readings go live to a dashboard that authorised staff can access from anywhere. The next phase is [next stage]. The [programme] will give [them] the advanced theoretical and practical tools to take this work to the level where it can be validated, published, and deployed in real clinical settings.

What brought [them] to [university] specifically was not just the programme. It was what sits behind it. [Named lab or infrastructure]. [Named research programme or centre]. That is not marketing language. That is the environment where [their project] stops being a prototype and becomes something that can be clinically validated and published. The curriculum covers exactly what [they] need to close the technical gaps in [their] own work, from [module] to [module].

After completing the [programme] [they] plan to [concrete action], [specific output], and ultimately return to [country] to [specific mission]. The talent is here. What is missing is the infrastructure and the knowledge base to support it. [They are] ready to do the work."

WHY THIS SCORED 82 AND HOW TO BEAT IT:
- P1 opens with the human cost, not a statistic. Zero AI language. Ends with a decision, not a description.
- P2 uses only named, numbered, verifiable details. Every project is named. Every credential has a number.
- P3 describes the current project technically — named sensors, named outputs, named next phase. The reader feels work already in motion.
- P4 names specific infrastructure, not generic praise. Each sentence connects one school resource to one project gap.
- P5 closes the loop to P1. Ends with a short, direct, unadorned commitment.
- To score above 82: P4 must name a real faculty member whose research connects to the applicant's project. P5 must include a timeframe and a named output. P1 must avoid any reference to the applicant personally until the final sentence of that paragraph.

STRUCTURE — five paragraphs:
P1 THE PROBLEM: Human cost of a broken system. No statistics. No "I" until the final sentence. Show what the problem prevents and costs every day.
P2 THE PROOF: Named degree, grade, institution, year. Named projects with technical detail. Numbers only. No vague claims.
P3 THE PROJECT: Current work in detail. Named technology. Current stage. Specific gap this programme closes.
P4 WHY THIS SCHOOL: Named labs, faculty research areas, modules. One sentence per connection. Use your own knowledge of the named university to fill gaps the applicant could not provide. If you have no reliable knowledge, add [APPLICANT SHOULD VERIFY] at end of paragraph.
P5 THE MISSION: Country, output, timeframe, who it serves. Close the loop to P1. No wishes.

RULES — all non-negotiable:
- First person singular. Never she, he, or they.
- No hyphens anywhere.
- Banned: delve, leverage, passionate, transformative, dynamic, journey, ecosystem, impactful, testament, firsthand, witnessed, stark, cutting-edge, world-class, top-notch, growing up, I have always been, since a young age, committed to, driven by, bridge the gap, make a positive impact, give it my all, I am eager, tirelessly. Rewrite in plain direct language.
- No bullet points. No headers. Five paragraphs only.
- Show not tell. Every claim needs evidence in the same sentence.
- Achievements only where they prove capacity.
- Sentences under 28 words. Vary the rhythm.
- No invented facts. Use only what the applicant provided plus verified school knowledge.

SELF-CHECK before returning:
1. Any banned word? Rewrite that sentence.
2. P4 uses general praise instead of named specific connections? Rewrite P4.
3. P5 ends with a wish or pledge? Replace with concrete action, place, timeframe.
4. Any claim without evidence in the same sentence? Replace with the evidence.
5. Does this SOP meet the gold standard above? If not, rewrite the weakest paragraph.`;

const BUILD_PROMPT = (info) => `${SOP_RULES}

APPLICANT DATA:
${info.name ? `Name: ${info.name}` : ""}
${info.purpose ? `Purpose: ${info.purpose}` : ""}
${info.university ? `University: ${info.university}` : ""}
${info.scholarship ? `Scholarship: ${info.scholarship}` : ""}
${info.field ? `Field: ${info.field}` : ""}
${info.degree ? `Degree level: ${info.degree}` : ""}
${info.country ? `Country: ${info.country}` : ""}
${info.countryChallenge ? `Problem being solved: ${info.countryChallenge}` : ""}
${info.motivation ? `Personal motivation: ${info.motivation}` : ""}
${info.academic ? `Academic background: ${info.academic}` : ""}
${info.experience ? `Experience and projects: ${info.experience}` : ""}
${info.currentProject ? `Current project (P3 heart): ${info.currentProject}` : ""}
${info.achievements ? `Achievements: ${info.achievements}` : ""}
${info.whyTarget ? `Why this school or scholarship: ${info.whyTarget}` : ""}
${info.goals ? `Post-graduation plan: ${info.goals}` : ""}
${info.extraInfo ? `Extra context: ${info.extraInfo}` : ""}
${info.targetLength ? `Target length: ${info.targetLength}` : "Aim for 700 to 900 words."}

Write the SOP now. Five paragraphs. No preamble. After the SOP write on a new line: ---WORD_COUNT--- followed by the word count.`;

const SCRATCH_PROMPT = (info) => `${SOP_RULES}

APPLICANT DATA — raw material only, write from it:
${info.name && info.name.toLowerCase() !== "skip" ? `Name: ${info.name}` : ""}
${info.country ? `Country: ${info.country}` : ""}
${info.field ? `Field: ${info.field}` : ""}
${info.purpose ? `Purpose: ${info.purpose}` : ""}
${info.countryChallenge ? `Problem being solved: ${info.countryChallenge}` : ""}
${info.motivation ? `Personal motivation: ${info.motivation}` : ""}
${info.academic ? `Academic background: ${info.academic}` : ""}
${info.experience ? `Experience and projects: ${info.experience}` : ""}
${info.currentProject ? `Current project (P3 heart): ${info.currentProject}` : ""}
${info.whyTarget ? `Why this school or scholarship: ${info.whyTarget}` : ""}
${info.goals ? `Post-graduation plan: ${info.goals}` : ""}
${info.achievements && info.achievements.toLowerCase() !== "none" ? `Achievements: ${info.achievements}` : ""}
${info.extraInfo && info.extraInfo.toLowerCase() !== "nothing" ? `Extra context: ${info.extraInfo}` : ""}
${info.targetLength ? `Target length: ${info.targetLength}` : "Aim for 700 to 900 words."}

Write the SOP now. Five paragraphs. Match the gold standard voice. No preamble. After the SOP write on a new line: ---WORD_COUNT--- followed by the word count.`;

const SECTION_SCORES = [
  "Opening Hook", "Academic Background", "Motivation & Purpose",
  "Research/Career Goals", "Why This School/Scholarship",
  "Relevant Experience", "Personal Story", "Writing Quality",
  "Fit & Alignment", "Closing",
];

// ── Styles ────────────────────────────────────────────────────────────────────

const STYLES = `
@import url('https://fonts.googleapis.com/css2?family=Fraunces:ital,wght@0,300;0,400;0,600;0,700;1,300;1,400&family=DM+Sans:wght@300;400;500;600&family=JetBrains+Mono:wght@400;500&display=swap');

*, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }


:root {
  --bg: #f8f6f2;
  --surface: #ffffff;
  --surface2: #f2efe9;
  --border: rgba(0,0,0,0.08);
  --border2: rgba(0,0,0,0.14);
  --text: #1a1714;
  --text2: #5a5550;
  --text3: #9a9590;
  --accent: #1a3a6b;
  --accent-bg: #eef2f9;
  --accent-border: #b8c8e8;
  --gold: #8a6a00;
  --gold-bg: #fdf6e3;
  --gold-border: #e8d090;
  --danger: #8a1a1a;
  --danger-bg: #fdf0f0;
  --danger-border: #e8b0b0;
  --success: #1a5a2a;

  --success-bg: #f0f8f2;
  --success-border: #a0d0a8;
  --radius: 10px;
  --radius-sm: 6px;
  --shadow: 0 1px 3px rgba(0,0,0,0.06), 0 1px 2px rgba(0,0,0,0.04);
  --shadow-md: 0 4px 16px rgba(0,0,0,0.08);
}

body { background: var(--bg); font-family: 'DM Sans', sans-serif; color: var(--text); }

.sop-wrap { max-width: 800px; margin: 0 auto; padding: 40px 20px 100px; }

.sop-header { margin-bottom: 32px; padding-bottom: 20px; border-bottom: 1px solid var(--border); }
.sop-title { font-family: 'Fraunces', Georgia, serif; font-size: 26px; font-weight: 600; letter-spacing: -0.4px; color: var(--text); }
.sop-title em { font-style: italic; color: var(--accent); }
.sop-sub { font-size: 13px; color: var(--text2); margin-top: 4px; font-weight: 300; }

.card {
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  padding: 24px;
  box-shadow: var(--shadow);
  margin-bottom: 16px;
}

.card-title {
  font-family: 'Fraunces', serif;
  font-size: 18px;
  font-weight: 600;
  color: var(--text);
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.field-label {
  font-family: 'JetBrains Mono', monospace;
  font-size: 10px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: var(--text3);
  margin-bottom: 6px;
  display: block;
}

input, select, textarea {
  width: 100%;
  font-family: 'DM Sans', sans-serif;
  font-size: 14px;
  padding: 10px 14px;
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  background: var(--surface2);
  color: var(--text);
  outline: none;
  transition: border-color 0.15s, box-shadow 0.15s;
}
input:focus, select:focus, textarea:focus {
  border-color: var(--accent-border);
  box-shadow: 0 0 0 3px rgba(26,58,107,0.06);
  background: var(--surface);
}
select option { background: var(--surface); }
textarea { resize: vertical; line-height: 1.7; }

.field-row { margin-bottom: 16px; }
.field-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 14px; margin-bottom: 16px; }

.btn {
  font-family: 'DM Sans', sans-serif;
  font-size: 13px;
  font-weight: 500;
  height: 40px;
  padding: 0 20px;
  border-radius: var(--radius-sm);
  border: 1px solid var(--border);
  background: var(--surface);
  color: var(--text);
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  transition: all 0.15s;
  white-space: nowrap;
}
.btn:hover:not(:disabled) { background: var(--surface2); border-color: var(--border2); }
.btn:disabled { opacity: 0.3; cursor: not-allowed; }
.btn-primary { background: var(--accent); color: #fff; border-color: var(--accent); }
.btn-primary:hover:not(:disabled) { background: #0f2a55; border-color: #0f2a55; }
.btn-gold { background: var(--gold-bg); color: var(--gold); border-color: var(--gold-border); }
.btn-gold:hover:not(:disabled) { background: #f5edcc; }
.btn-danger { background: var(--danger-bg); color: var(--danger); border-color: var(--danger-border); }
.btn-sm { height: 32px; padding: 0 12px; font-size: 12px; }

.mode-grid { display: grid; grid-template-columns: repeat(3,1fr); gap: 10px; margin-bottom: 20px; }
.mode-card {
  border: 1px solid var(--border);
  border-radius: var(--radius);
  padding: 18px 16px;
  cursor: pointer;
  transition: all 0.15s;
  background: var(--surface2);
  text-align: center;
}
.mode-card:hover { border-color: var(--border2); background: var(--surface); }
.mode-card.selected { border-color: var(--accent-border); background: var(--accent-bg); }
.mode-icon { font-size: 24px; margin-bottom: 8px; }
.mode-label { font-family: 'Fraunces', serif; font-size: 15px; font-weight: 600; color: var(--text); margin-bottom: 4px; }
.mode-desc { font-size: 11px; color: var(--text3); line-height: 1.5; }
.mode-card.selected .mode-desc { color: var(--accent); opacity: 0.8; }

.purpose-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 8px; }
.purpose-chip {
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  padding: 10px 14px;
  cursor: pointer;
  font-size: 13px;
  color: var(--text2);
  background: var(--surface2);
  transition: all 0.15s;
  text-align: center;
}
.purpose-chip:hover { border-color: var(--border2); color: var(--text); }
.purpose-chip.selected { border-color: var(--accent-border); background: var(--accent-bg); color: var(--accent); font-weight: 500; }

.score-bar-bg { height: 5px; background: var(--surface2); border-radius: 3px; overflow: hidden; margin-top: 6px; }
.score-bar-fill { height: 100%; border-radius: 3px; transition: width 1s ease; }

.section-score {
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  padding: 16px;
  margin-bottom: 10px;
  background: var(--surface);
}
.section-score-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}
.section-score-name { font-weight: 600; font-size: 13px; color: var(--text); }
.section-score-num { font-family: 'JetBrains Mono', monospace; font-size: 18px; font-weight: 500; }
.section-quote {
  font-style: italic;
  font-size: 12px;
  color: var(--text3);
  border-left: 2px solid var(--border2);
  padding-left: 10px;
  margin: 8px 0;
}
.section-feedback { font-size: 13px; color: var(--text2); line-height: 1.7; margin-bottom: 8px; }
.section-suggestion {
  font-size: 12px;
  color: var(--accent);
  background: var(--accent-bg);
  border-radius: var(--radius-sm);
  padding: 8px 12px;
  border: 1px solid var(--accent-border);
}

.overall-score-ring {
  width: 90px; height: 90px;
  border-radius: 50%;
  display: flex; flex-direction: column;
  align-items: center; justify-content: center;
  flex-shrink: 0;
  border: 3px solid;
}

.tag {
  display: inline-block;
  padding: 3px 10px;
  border-radius: 12px;
  font-family: 'JetBrains Mono', monospace;
  font-size: 10px;
  font-weight: 500;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}
.tag-success { background: var(--success-bg); color: var(--success); border: 1px solid var(--success-border); }
.tag-gold { background: var(--gold-bg); color: var(--gold); border: 1px solid var(--gold-border); }
.tag-danger { background: var(--danger-bg); color: var(--danger); border: 1px solid var(--danger-border); }
.tag-neutral { background: var(--surface2); color: var(--text3); border: 1px solid var(--border); }

.sop-output {
  font-family: 'Fraunces', Georgia, serif;
  font-size: 16px;
  line-height: 2;
  color: var(--text);
  white-space: pre-wrap;
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  padding: 32px;
}

.sop-editable {
  font-family: 'Fraunces', Georgia, serif;
  font-size: 16px;
  line-height: 2;
  color: var(--text);
  background: var(--surface);
  border: 1px solid var(--accent-border);
  border-radius: var(--radius);
  padding: 32px;
  width: 100%;
  min-height: 500px;
  outline: none;
  box-shadow: 0 0 0 3px rgba(26,58,107,0.04);
  resize: vertical;
}

.divider { height: 1px; background: var(--border); margin: 20px 0; }

.spinner {
  width: 16px; height: 16px;
  border: 2px solid rgba(26,58,107,0.2);
  border-top-color: var(--accent);
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
  flex-shrink: 0;
}
@keyframes spin { to { transform: rotate(360deg); } }

.progress-wrap { margin-top: 12px; }
.progress-bar { height: 3px; background: var(--surface2); border-radius: 3px; overflow: hidden; }
.progress-fill { height: 100%; background: var(--accent); border-radius: 3px; transition: width 0.3s; }

.actions-row { display: flex; gap: 10px; flex-wrap: wrap; margin-top: 16px; }

.key-input {
  font-family: 'JetBrains Mono', monospace;
  font-size: 13px;
  letter-spacing: 0.05em;
}
.key-hint { font-size: 12px; color: var(--text3); margin-top: 6px; }
.key-hint a { color: var(--accent); }
.key-hint.valid { color: var(--success); }

.history-item {
  display: flex; align-items: center; gap: 12px;
  padding: 12px 16px;
  border-bottom: 1px solid var(--border);
  cursor: pointer;
  transition: background 0.1s;
}
.history-item:last-child { border-bottom: none; }
.history-item:hover { background: var(--surface2); }

.err { background: var(--danger-bg); border: 1px solid var(--danger-border); border-radius: var(--radius-sm); padding: 12px 16px; font-size: 13px; color: var(--danger); margin-top: 12px; }

/* Dark mode */
body.dark { --bg: #1a1918; --surface: #242220; --surface2: #2c2a28; --border: rgba(255,255,255,0.08); --border2: rgba(255,255,255,0.14); --text: #f0ede8; --text2: #b0ada8; --text3: #707570; --accent-bg: rgba(26,58,107,0.2); --accent-border: rgba(100,140,200,0.3); --gold-bg: rgba(138,106,0,0.12); --gold-border: rgba(138,106,0,0.3); --danger-bg: rgba(138,26,26,0.12); --danger-border: rgba(138,26,26,0.3); --success-bg: rgba(26,90,42,0.12); --success-border: rgba(26,90,42,0.3); }
body.dark input, body.dark select, body.dark textarea { background: #1a1918; color: #f0ede8; }
body.dark .sop-editable { background: #1a1918; color: #f0ede8; }
`;

// ── Helpers ───────────────────────────────────────────────────────────────────

function scoreColor(s) {
  if (s >= 80) return "#1a5a2a";
  if (s >= 65) return "#8a6a00";
  if (s >= 50) return "#c06010";
  return "#8a1a1a";
}

function recommendationTag(r) {
  if (!r) return null;
  if (r.includes("Strong")) return "tag-success";
  if (r.includes("Borderline")) return "tag-gold";
  if (r === "Recommend") return "tag-success";
  return "tag-danger";
}

function timeAgo(ts) {
  const diff = Date.now() - ts;
  const m = Math.floor(diff / 60000);
  const h = Math.floor(diff / 3600000);
  const d = Math.floor(diff / 86400000);
  if (m < 1) return "Just now";
  if (m < 60) return `${m}m ago`;
  if (h < 24) return `${h}h ago`;
  if (d === 1) return "Yesterday";
  return `${d}d ago`;
}

function getSOPHistory() {
  try { return JSON.parse(localStorage.getItem("lliuq_sop_history") || "[]"); }
  catch { return []; }
}

function saveSOPHistory(item) {
  try {
    const existing = getSOPHistory();
    const updated = [item, ...existing].slice(0, 30);
    localStorage.setItem("lliuq_sop_history", JSON.stringify(updated));
  } catch { }
}

// ── SearchableSelect Component ────────────────────────────────────────────────

function SearchableSelect({ options, value, onChange, placeholder = "Search..." }) {
  const [query, setQuery] = useState("");
  const [open, setOpen] = useState(false);
  const [writingStyle, setWritingStyle] = useState("problem-to-mission");
  const [pendingData, setPendingData] = useState(null);
  const ref = useRef(null);

  const pinned = options.filter(o => o === "Other (type below)");
  const rest = options.filter(o => o !== "Other (type below)");
  const filtered = [
    ...rest.filter(o => o.toLowerCase().includes(query.toLowerCase())),
    ...pinned,
  ];

  useEffect(() => {
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const select = (opt) => { onChange(opt); setQuery(""); setOpen(false); };
  const clear = () => { onChange(""); setQuery(""); };
  const displayLabel = value && value !== "Other (type below)" ? value : value === "Other (type below)" ? "Other (type below)" : "";

  return (
    <div ref={ref} style={{ position: "relative" }}>
      <div
        style={{
          display: "flex", alignItems: "center",
          border: "1px solid var(--border)", borderRadius: 6,
          background: "var(--surface)", overflow: "hidden",
          boxShadow: open ? "0 0 0 3px rgba(26,58,107,0.06)" : "none",
          borderColor: open ? "var(--accent-border)" : "var(--border)",
          transition: "border-color 0.15s, box-shadow 0.15s",
        }}
      >
        <input
          style={{
            flex: 1, border: "none", background: "transparent",
            padding: "9px 12px", fontSize: 15, color: "var(--text)",
            outline: "none", fontFamily: "inherit",
          }}
          value={open ? query : displayLabel}
          placeholder={displayLabel || placeholder}
          onFocus={() => { setOpen(true); setQuery(""); }}
          onChange={e => setQuery(e.target.value)}
        />
        {value && (
          <button
            onClick={clear}
            style={{ background: "none", border: "none", cursor: "pointer", padding: "0 10px", color: "var(--text3)", fontSize: 16, lineHeight: 1 }}
            title="Clear"
          >×</button>
        )}
        <div style={{ padding: "0 10px", color: "var(--text3)", fontSize: 11, pointerEvents: "none" }}>▼</div>
      </div>

      {open && (
        <div style={{
          position: "absolute", top: "calc(100% + 4px)", left: 0, right: 0,
          background: "var(--surface)", border: "1px solid var(--border)",
          borderRadius: 6, boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
          maxHeight: 220, overflowY: "auto", zIndex: 999,
        }}>
          {filtered.length === 0 ? (
            <div style={{ padding: "12px 14px", color: "var(--text3)", fontSize: 13 }}>No results found</div>
          ) : filtered.map(opt => (
            <div
              key={opt}
              onClick={() => select(opt)}
              style={{
                padding: "9px 14px", fontSize: 14, cursor: "pointer",
                background: value === opt ? "var(--accent-bg)" : "transparent",
                color: value === opt ? "var(--accent)" : "var(--text)",
                fontWeight: value === opt ? 500 : 400,
                borderTop: opt === "Other (type below)" ? "1px solid var(--border)" : "none",
                transition: "background 0.1s",
              }}
              onMouseEnter={e => { if (value !== opt) e.currentTarget.style.background = "var(--hover-bg, rgba(0,0,0,0.04))"; }}
              onMouseLeave={e => { if (value !== opt) e.currentTarget.style.background = "transparent"; }}
            >
              {opt}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

// ── Main Component ────────────────────────────────────────────────────────────

export default function SOP() {
  const [apiKey, setApiKey] = useState(() => getGroqKey());
  const [keyInput, setKeyInput] = useState("");
  const [showKey, setShowKey] = useState(false);
  const [keyConfirmed, setKeyConfirmed] = useState(() => !!getGroqKey());
  const [keyError, setKeyError] = useState("");

  const [screen, setScreen] = useState("home"); // home | setup | review | build | result | history
  const [mode, setMode] = useState(null);
  const [purpose, setPurpose] = useState("");
  const [university, setUniversity] = useState("");
  const [universityCustom, setUniversityCustom] = useState("");
  const [scholarship, setScholarship] = useState("");
  const [scholarshipCustom, setScholarshipCustom] = useState("");
  const [field, setField] = useState("");
  const [fieldCustom, setFieldCustom] = useState("");

  // Review mode
  const [existingSOP, setExistingSOP] = useState("");
  const [reviewResult, setReviewResult] = useState(null);

  // Build / Scratch mode
  const [formData, setFormData] = useState({
    name: "", country: "", countryChallenge: "", degree: "",
    academic: "", experience: "", achievements: "", whyTarget: "",
    goals: "", motivation: "", targetLength: "", extraInfo: "",
    currentProject: "",
  });

  // Scratch chat mode
  const [scratchMessages, setScratchMessages] = useState([]);
  const [scratchInput, setScratchInput] = useState("");
  const [scratchStep, setScratchStep] = useState(0);
  const [scratchData, setScratchData] = useState({});
  const [scratchDone, setScratchDone] = useState(false);
  const scratchEndRef = useRef(null);

  // Output
  const [sopText, setSopText] = useState("");
  const [isEditing, setIsEditing] = useState(false);
  const [wordCount, setWordCount] = useState(0);

  const [loading, setLoading] = useState(false);
  const [loadingMsg, setLoadingMsg] = useState("");
  const [error, setError] = useState("");
  const [history, setHistory] = useState(getSOPHistory());

  useEffect(() => {
    const sync = () => {
      const k = getGroqKey();
      setApiKey(k);
      setKeyConfirmed(!!k);
    };
    window.addEventListener("storage", sync);
    return () => window.removeEventListener("storage", sync);
  }, []);

  const [currentSessionId, setCurrentSessionId] = useState(null);

  const saveKey = () => {
    const t = keyInput.trim();
    if (!t.startsWith("gsk_")) { setKeyError("Groq keys start with gsk_"); return; }
    setApiKey(t);
    saveGroqKey(t);
    setKeyConfirmed(true);
    setKeyError("");
  };

  const SCRATCH_QUESTIONS = [
    {
      key: "name",
      q: "What is your name?",
      placeholder: "Or type 'skip' if you prefer not to include it"
    },
    {
      key: "country",
      q: "Which country are you from, and which city or region did you grow up in or work in?",
      placeholder: "e.g. Somewhere, Antarctica — the more specific the better"
    },
    {
      key: "countryChallenge",
      q: "What is the specific problem in your country or field that you are trying to solve? Not a general issue — the actual gap. Who does it affect, how badly, and why has it not been fixed?",
      placeholder: "e.g. You understand what you are trying to solve better."
    },
    {
      key: "motivation",
      q: "Have you personally witnessed or experienced this problem? Tell me exactly what you saw or went through. Not what you read — what you actually encountered that made this feel urgent and personal to you.",
      placeholder: "A specific moment, a person, a failure you watched happen. The more specific and honest, the stronger your SOP."
    },
    {
      key: "academic",
      q: "Walk me through your academic background. Include the institution, the degree, your grade or class, the year you graduated, and any project or thesis that is directly relevant to what you want to do.",
      placeholder: "e.g. First Class in Computer Science, Lliuq University, 2009, CGPA 5.0/5.0.  Final year project name."
    },
    {
      key: "experience",
      q: "What have you built, researched, or worked on that is relevant to this application? For each thing, tell me: what it was, what it actually did, what role you played in it, and what you learned or proved through it.",
      placeholder: "e.g. Built a website that does this and that, be specific about your experience in your field ."
    },
    {
      key: "currentProject",
      q: "Do you have a current project, ongoing research, or a specific idea you are already working on? If yes — describe it in detail. What does it do, what technology does it use, what stage is it at right now, and what is the one technical gap stopping you from taking it further?",
      placeholder: "e.g. I am currently conducting a research on abc. Explain in full detail.  ."
    },
    {
      key: "whyTarget",
      q: "Why this specific university or scholarship? Do not tell me it is prestigious or well-ranked. Tell me which specific lab, research group, module, faculty member, or resource there directly connects to the gap in your work — and how.",
      placeholder: "e.g. The National Software research hub at East London has the sensor integration infrastructure my project needs. Professor X's work on Nano device Edge Computing, will help me close the gaps in my knowledge, be true to yourself."
    },
    {
      key: "goals",
      q: "What will you do after you finish this degree? Be specific — name the country, the role, the thing you will build or establish, and who it will serve. Give me a rough timeframe.",
      placeholder: "e.g. Return to Antarctica within a year of graduating. Deploy my model in three public hospital where it does abc works. "
    },
    {
      key: "achievements",
      q: "Are there any awards, recognitions, or results from your work that prove your capacity to do this — not to impress, but to show you have already earned trust in this field?",
      placeholder: "e.g. African Women Scholarship. Or type 'none' if you prefer to let the work speak."
    },
    {
      key: "extraInfo",
      q: "Is there anything in your background that needs context — a gap in your CV, a difficult circumstance you worked through, something that is not obvious from the rest of what you have told me?",
      placeholder: "e.g. I worked full time for 3 years at ABC company while completing my degree. Or type 'nothing' to move on."
    },
    {
      key: "targetLength",
      q: "Last one — does the application have a word count or page limit?",
      placeholder: "e.g. 500 words, 2 pages, or 'no limit'"
    },
  ];

  const startScratch = () => {
    // Pre-fill data from setup screen so we don't ask again
    const prefilled = {};
    const getUniv = university === "Other (type below)" ? universityCustom : university;
    const getSchol = scholarship === "Other (type below)" ? scholarshipCustom : scholarship;
    const getFld = field === "Other" ? fieldCustom : field;
    if (purpose) prefilled.purpose = purpose;
    if (getUniv || getSchol) prefilled.whyTarget = [getUniv, getSchol].filter(Boolean).join(" / ");
    if (getFld) prefilled.field = getFld;

    // Find first unanswered question
    const firstUnanswered = SCRATCH_QUESTIONS.findIndex(q => !prefilled[q.key]);
    const startStep = firstUnanswered === -1 ? 0 : firstUnanswered;

    setScratchData(prefilled);
    setScratchStep(startStep);
    setScratchMessages([{ role: "ai", text: "Hey! So you want to write your Statement of Purpose and you want it to actually sound like you. Good call.\n\nHere is how this works: I ask you questions, you answer however feels natural, and when we are done I write the whole thing. No boxes to fill, no templates, just a real conversation.\n\nSome questions might feel personal. That is the point. The more honest you are, the better your SOP will be.\n\nAlright, let us start.\n\n" + SCRATCH_QUESTIONS[startStep].q }]);
    setScratchDone(false);
  };

  const handleScratchSend = async () => {
    const input = scratchInput.trim();
    if (!input) return;
    
    if (scratchDone && pendingData) {
        setScratchMessages(prev => [...prev, { role: "user", text: input }]);
        setScratchInput("");
        if (input.toLowerCase().trim() === "write it" || input.toLowerCase().includes("write it")) {
          setTimeout(() => generateScratchSOP(pendingData), 300);
        } else {
          const improved = { ...pendingData, extraInfo: (pendingData.extraInfo && pendingData.extraInfo.toLowerCase() !== "nothing" ? pendingData.extraInfo + ". " : "") + input };
          setPendingData(improved);
          setScratchMessages(prev => [...prev, { role: "ai", text: "Got it, added to your SOP. Anything else to improve? Or type 'write it' when ready." }]);
          scratchEndRef.current?.scrollIntoView({ behavior: "smooth" });
        }
        return;
      }
    
    const currentQ = SCRATCH_QUESTIONS[scratchStep];
    const updatedData = { ...scratchData, [currentQ.key]: input };
    setScratchData(updatedData);
    setScratchMessages(prev => [...prev, { role: "user", text: input }]);
    setScratchInput("");
    const nextStep = scratchStep + 1;
    if (nextStep < SCRATCH_QUESTIONS.length) {
      setScratchStep(nextStep);
      setTimeout(() => {
        setScratchMessages(prev => [...prev, { role: "ai", text: SCRATCH_QUESTIONS[nextStep].q }]);
        scratchEndRef.current?.scrollIntoView({ behavior: "smooth" });
      }, 400);
    } else {
      setScratchDone(true);
      setTimeout(() => {
        setScratchMessages(prev => [...prev, { role: "ai", text: "Perfect. I have everything I need. Give me a moment to write your SOP..." }]);
        scratchEndRef.current?.scrollIntoView({ behavior: "smooth" });
      }, 400);
      setTimeout(async () => {
        setLoading(true);
        try {
          const info = { ...updatedData, university: updatedData.whyTarget || "", scholarship: updatedData.purpose || "" };
          const raw = await callGroq(
            "You are a gifted ghostwriter. Write a complete Statement of Purpose now. Pure and naturally flowing. No bullet points. No headers. No preamble. Start writing the SOP immediately.",
            SCRATCH_PROMPT(info),
            "meta-llama/llama-4-scout-17b-16e-instruct",
            0.3
          );
          const parts = raw.split("---WORD_COUNT---");
          const text = parts[0].trim();
          const wc = text.split(/\s+/).filter(Boolean).length;
          setSopText(text);
          setWordCount(wc);
          setScreen("sop-result");
          const sessionId = Date.now().toString();
          setCurrentSessionId(sessionId);
          const item = {
            id: sessionId, mode: "scratch", ts: Date.now(),
            title: `From Scratch — ${updatedData.field || "SOP"}`,
            subtitle: `${wc} words · ${updatedData.purpose || ""}`,
            purpose: updatedData.purpose, formData: updatedData, sopText: text,
          };
          saveSOPHistory(item);
          saveSession({ tool: "sop", title: item.title, subtitle: item.subtitle });
          setHistory(getSOPHistory());
        } catch (e) {
          setScratchMessages(prev => [...prev, { role: "ai", text: "Something went wrong: " + e.message + ". Please try again." }]);
        } finally {
          setLoading(false);
        }
      }, 1000);
    }
  };

  const callGroq = async (systemPrompt, userContent, model = "meta-llama/llama-4-scout-17b-16e-instruct", temperature = 0.3) => {
    const res = await fetch("https://api.groq.com/openai/v1/chat/completions", {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${apiKey}` },
      body: JSON.stringify({
        model,
        max_tokens: 8192,
        temperature,
        messages: [
          { role: "system", content: systemPrompt },
          { role: "user", content: userContent },
        ],
      }),
    });
    const d = await res.json();
    if (!res.ok) throw new Error(d?.error?.message || `API error ${res.status}`);
    return d.choices?.[0]?.message?.content || "";
  };

  const getUniversity = () => university === "Other (type below)" ? universityCustom : university;
  const getScholarship = () => scholarship === "Other (type below)" ? scholarshipCustom : scholarship;
  const getField = () => field === "Other" ? fieldCustom : field;


  const handleSOPFileUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const ext = file.name.split(".").pop().toLowerCase();

    if (ext === "txt") {
      const text = await file.text();
      setExistingSOP(text);
    } else if (ext === "pdf") {
      // Load PDF.js
      if (!window.pdfjsLib) {
        await new Promise((res, rej) => {
          const s = document.createElement("script");
          s.src = "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.min.js";
          s.onload = res; s.onerror = rej;
          document.head.appendChild(s);
        });
        window.pdfjsLib.GlobalWorkerOptions.workerSrc =
          "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js";
      }
      const buffer = await file.arrayBuffer();
      const pdf = await window.pdfjsLib.getDocument({ data: buffer }).promise;
      let fullText = "";
      for (let i = 1; i <= pdf.numPages; i++) {
        const page = await pdf.getPage(i);
        const content = await page.getTextContent();
        fullText += content.items.map(item => item.str).join(" ") + "\n\n";
      }
      setExistingSOP(fullText.trim());
    } else if (ext === "docx") {
      // Load mammoth.js for Word docs
      if (!window.mammoth) {
        await new Promise((res, rej) => {
          const s = document.createElement("script");
          s.src = "https://cdnjs.cloudflare.com/ajax/libs/mammoth/1.6.0/mammoth.browser.min.js";
          s.onload = res; s.onerror = rej;
          document.head.appendChild(s);
        });
      }
      const buffer = await file.arrayBuffer();
      const result = await window.mammoth.convertToHtml({ arrayBuffer: buffer });
      // Strip HTML tags for the text version but keep structure
      const div = document.createElement("div");
      div.innerHTML = result.value;
      // Preserve paragraph breaks
      const paras = div.querySelectorAll("p, h1, h2, h3, h4, li");
      const text = Array.from(paras).map(p => p.textContent.trim()).filter(Boolean).join("\n\n");
      setExistingSOP(text);
    } else {
      alert("Please upload a PDF, Word (.docx), or text file.");
    }
    e.target.value = "";
  };


  const handleReview = async () => {
    if (!existingSOP.trim()) return;
    setLoading(true);
    setLoadingMsg("The committee is reviewing your statement...");
    setError("");
    try {
      const context = {
        purpose,
        university: getUniversity(),
        scholarship: getScholarship(),
        field: getField(),
      };
      const raw = await callGroq("You are a strict admissions committee reviewer. Respond only in the exact JSON format requested.", REVIEW_PROMPT(existingSOP, context), "llama-3.3-70b-versatile");
      const cleaned = raw.replace(/```json|```/g, "").trim();
      const result = JSON.parse(cleaned);
      setReviewResult(result);
      setScreen("review-result");

      const sessionId = Date.now().toString();
      setCurrentSessionId(sessionId);
      const item = {
        id: sessionId, mode: "review", ts: Date.now(),
        title: `Review — ${getUniversity() || getScholarship() || "SOP"}`,
        subtitle: `Score: ${result.overallScore}/100 · ${result.recommendation}`,
        purpose, university: getUniversity(), scholarship: getScholarship(),
        field: getField(), existingSOP, reviewResult: result,
      };
      saveSOPHistory(item);
      saveSession({ tool: "sop", title: item.title, subtitle: item.subtitle });
      setHistory(getSOPHistory());
    } catch (e) {
      setError("Review failed: " + e.message);
    } finally {
      setLoading(false);
    }
  };

  const handleBuild = async () => {
    setLoading(true);
    setLoadingMsg("Writing your statement of purpose...");
    setError("");
    try {
      const info = {
        ...formData,
        purpose,
        university: getUniversity(),
        scholarship: getScholarship(),
        field: getField(),
      };
      const raw = await callGroq(
        "You are an elite SOP writer. Write exactly as instructed. Produce flowing prose with no markdown headers or bullets inside the SOP.",
        BUILD_PROMPT(info)
      );
      const parts = raw.split("---WORD_COUNT---");
      const text = parts[0].trim();
      const wc = text.split(/\s+/).filter(Boolean).length;
      setSopText(text);
      setWordCount(wc);
      setScreen("sop-result");

      const sessionId = Date.now().toString();
      setCurrentSessionId(sessionId);
      const item = {
        id: sessionId, mode, ts: Date.now(),
        title: `${mode === "scratch" ? "From Scratch" : "Built"} — ${getUniversity() || getScholarship() || getField()}`,
        subtitle: `${wc} words · ${purpose}`,
        purpose, university: getUniversity(), scholarship: getScholarship(),
        field: getField(), formData, sopText: text,
      };
      saveSOPHistory(item);
      saveSession({ tool: "sop", title: item.title, subtitle: item.subtitle });
      setHistory(getSOPHistory());
    } catch (e) {
      setError("Build failed: " + e.message);
    } finally {
      setLoading(false);
    }
  };

  const exportPDF = async () => {
    const text = sopText;
    if (!text) return;

    if (!window.jspdf) {
      await new Promise((res, rej) => {
        const s = document.createElement("script");
        s.src = "https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js";
        s.onload = res; s.onerror = rej;
        document.head.appendChild(s);
      });
    }

    const { jsPDF } = window.jspdf;
    const doc = new jsPDF({ unit: "mm", format: "a4" });
    const pageW = 210, pageH = 297;
    const marginL = 20, marginR = 20, marginT = 25, marginB = 20;
    const contentW = pageW - marginL - marginR;
    let y = marginT;

    const checkPage = (needed = 8) => {
      if (y + needed > pageH - marginB) { doc.addPage(); y = marginT; }
    };

    // Title block
    doc.setFont("times", "bold");
    doc.setFontSize(16);
    doc.setTextColor(26, 58, 107);
    doc.text("Statement of Purpose", marginL, y);
    y += 8;

    if (getUniversity() || getScholarship()) {
      doc.setFont("times", "normal");
      doc.setFontSize(11);
      doc.setTextColor(90, 85, 80);
      const sub = [getUniversity(), getScholarship()].filter(Boolean).join(" · ");
      doc.text(sub, marginL, y);
      y += 6;
    }

    doc.setDrawColor(26, 58, 107);
    doc.setLineWidth(0.5);
    doc.line(marginL, y, marginL + contentW, y);
    y += 10;

    // Body text
    doc.setFont("times", "normal");
    doc.setFontSize(12);
    doc.setTextColor(26, 23, 20);

    const paragraphs = text.split(/\n\n+/);
    paragraphs.forEach(para => {
      const lines = doc.splitTextToSize(para.trim(), contentW);
      lines.forEach(line => {
        checkPage(7);
        doc.text(line, marginL, y);
        y += 6.5;
      });
      y += 3;
    });

    // Footer
    const pageCount = doc.internal.getNumberOfPages();
    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      doc.setFont("helvetica", "normal");
      doc.setFontSize(8);
      doc.setTextColor(150, 145, 140);
      doc.text(`Page ${i} of ${pageCount}`, pageW - marginR, pageH - 10, { align: "right" });
      doc.text("Generated via lliuq SOP", marginL, pageH - 10);
    }

    doc.save(`sop-${Date.now()}.pdf`);
  };

  const exportWord = async () => {
    const text = sopText;
    if (!text) return;

    try {
      if (!window.docx) {
        await new Promise((res, rej) => {
          const s = document.createElement("script");
          s.src = "https://unpkg.com/docx@7.8.2/build/index.js";
          s.onload = res; s.onerror = rej;
          document.head.appendChild(s);
        });
      }

      const { Document, Paragraph, TextRun, HeadingLevel, Packer, AlignmentType } = window.docx;

      const paragraphs = text.split(/\n\n+/).filter(Boolean);
      const children = [
        new Paragraph({
          text: "Statement of Purpose",
          heading: HeadingLevel.HEADING_1,
          spacing: { after: 200 },
        }),
      ];

      if (getUniversity() || getScholarship()) {
        children.push(new Paragraph({
          children: [new TextRun({
            text: [getUniversity(), getScholarship()].filter(Boolean).join(" · "),
            color: "5a5550", size: 22,
          })],
          spacing: { after: 400 },
        }));
      }

      paragraphs.forEach(para => {
        children.push(new Paragraph({
          children: [new TextRun({ text: para.trim(), size: 24 })],
          spacing: { after: 200, line: 360 },
          alignment: AlignmentType.JUSTIFIED,
        }));
      });

      const doc = new Document({
        sections: [{ properties: {}, children }],
      });

      const blob = await Packer.toBlob(doc);
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url; a.download = `sop-${Date.now()}.docx`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);

    } catch (err) {
      alert("Word export failed: " + err.message);
    }
  };

  const loadHistoryItem = (item) => {
    setMode(item.mode);
    setPurpose(item.purpose || "");
    setUniversity(item.university || "");
    setScholarship(item.scholarship || "");
    setField(item.field || "");
    if (item.mode === "review") {
      setExistingSOP(item.existingSOP || "");
      setReviewResult(item.reviewResult);
      setScreen("review-result");
    } else {
      setFormData(item.formData || {});
      setSopText(item.sopText || "");
      setWordCount((item.sopText || "").split(/\s+/).filter(Boolean).length);
      setScreen("sop-result");
    }
  };

  // ── KEY SCREEN ──
  if (!keyConfirmed) return (
    <div style={{ minHeight: "100vh", background: "var(--bg)", display: "flex", alignItems: "center", justifyContent: "center", padding: 24 }}>
      <style>{STYLES}</style>
      <div className="card" style={{ maxWidth: 480, width: "100%", padding: "48px 40px", textAlign: "center" }}>
        <div className="crest" style={{ margin: "0 auto 20px" }}>✍️</div>
        <h1 className="sop-title" style={{ marginBottom: 16 }}>Key Required</h1>
        <p style={{ color: "var(--text2)", marginBottom: 24 }}>Please set your Groq API key in the navigation bar or on the Home page to use the SOP coach.</p>
        <button className="btn btn-primary" onClick={() => window.location.href = "/"}>Go to Home Page</button>
      </div>
    </div>
  );

  // ── HOME SCREEN ──
  if (screen === "home") return (
    <div style={{ minHeight: "calc(100vh - 60px)", background: "var(--bg)" }}>
      <style>{STYLES}</style>
      <div className="sop-wrap">
        <div className="sop-header">
          <div className="sop-title">Lliuq Prose<em>.  Your SOP Studio</em></div>
          <div className="sop-sub">Review, build, or write your SOP from scratch — tailored to your purpose, institution, and voice.</div>
        </div>

        <div className="card">
          <div className="card-title">What would you like to do?</div>
          <div className="mode-grid">
            {MODES.map(m => (
              <div key={m.id} className={`mode-card${mode === m.id ? " selected" : ""}`} onClick={() => setMode(m.id)}>
                <div className="mode-icon">{m.icon}</div>
                <div className="mode-label">{m.label}</div>
                <div className="mode-desc">{m.desc}</div>
              </div>
            ))}
          </div>
          <button className="btn btn-primary" style={{ width: "100%" }} disabled={!mode}
            onClick={() => setScreen("setup")}>
            Continue →
          </button>
        </div>

        {history.length > 0 && (
          <div className="card" style={{ padding: 0, overflow: "hidden" }}>
            <div style={{ padding: "16px 20px", borderBottom: "1px solid var(--border)", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <span style={{ fontWeight: 600, fontSize: 14 }}>Recent sessions</span>
              <button className="btn btn-sm" onClick={() => setScreen("history")}>View all</button>
            </div>
            {history.slice(0, 5).map((item, i) => (
              <div key={i} className="history-item" onClick={() => loadHistoryItem(item)}>
                <div style={{ width: 32, height: 32, borderRadius: 6, background: "var(--accent-bg)", display: "flex", alignItems: "center", justifyContent: "center", color: "var(--accent)", flexShrink: 0 }}>
                  {item.mode === "review" ? "🔍" : item.mode === "scratch" ? "✍️" : "🏗"}
                </div>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontSize: 13, fontWeight: 500, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{item.title}</div>
                  <div style={{ fontSize: 11, color: "var(--text3)", marginTop: 2 }}>{item.subtitle}</div>
                </div>
                <div style={{ fontSize: 11, color: "var(--text3)", whiteSpace: "nowrap", flexShrink: 0 }}>{timeAgo(item.ts)}</div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );

  // ── SETUP SCREEN ──
  if (screen === "setup") return (
    <div style={{ minHeight: "calc(100vh - 60px)", background: "var(--bg)" }}>
      <style>{STYLES}</style>
      <div className="sop-wrap">
        <div className="sop-header">
          <button className="btn btn-sm" style={{ marginBottom: 12 }} onClick={() => setScreen("home")}>← Back</button>
          <div className="sop-title">{MODES.find(m => m.id === mode)?.icon} {MODES.find(m => m.id === mode)?.label}</div>
          <div className="sop-sub">Tell us about your application so we can tailor everything to your specific situation.</div>
        </div>

        {/* Purpose */}
        <div className="card">
          <div className="card-title">What is this SOP for?</div>
          <div className="purpose-grid">
            {PURPOSE_TYPES.map(p => (
              <div key={p.id} className={`purpose-chip${purpose === p.id ? " selected" : ""}`} onClick={() => setPurpose(p.id)}>
                {p.label}
              </div>
            ))}
          </div>
        </div>

        {/* Institution details */}
        <div className="card">
          <div className="card-title">Institution & Programme</div>

          {(purpose === "admission" || purpose === "both" || purpose === "postgrad") && (
            <div className="field-row">
              <span className="field-label">University / Institution</span>
              <SearchableSelect
                options={TOP_UNIVERSITIES}
                value={university}
                onChange={setUniversity}
                placeholder="Search universities..."
              />
              {university === "Other (type below)" && (
                <input style={{ marginTop: 8 }} value={universityCustom} onChange={e => setUniversityCustom(e.target.value)} placeholder="Enter university name..." />
              )}
            </div>
          )}

          {(purpose === "scholarship" || purpose === "both") && (
            <div className="field-row">
              <span className="field-label">Scholarship</span>
              <SearchableSelect
                options={TOP_SCHOLARSHIPS}
                value={scholarship}
                onChange={setScholarship}
                placeholder="Search scholarships..."
              />
              {scholarship === "Other (type below)" && (
                <input style={{ marginTop: 8 }} value={scholarshipCustom} onChange={e => setScholarshipCustom(e.target.value)} placeholder="Enter scholarship name..." />
              )}
            </div>
          )}

          <div className="field-grid">
            <div>
              <span className="field-label">Field of Study</span>
              <select value={field} onChange={e => setField(e.target.value)}>
                <option value="">Select field...</option>
                {FIELDS.map(f => <option key={f} value={f}>{f}</option>)}
              </select>
              {field === "Other" && (
                <input style={{ marginTop: 8 }} value={fieldCustom} onChange={e => setFieldCustom(e.target.value)} placeholder="Enter field..." />
              )}
            </div>
            <div>
              <span className="field-label">Degree Level</span>
              <select value={formData.degree} onChange={e => setFormData(f => ({ ...f, degree: e.target.value }))}>
                <option value="">Select...</option>
                {["Bachelor's", "Master's", "PhD", "Postdoctoral", "Professional (MBA/JD/MD)"].map(d => <option key={d} value={d}>{d}</option>)}
              </select>
            </div>
          </div>
        </div>

        {/* Review mode — paste SOP */}
        {mode === "review" && (
          <div className="card">
            <div className="card-title">📋 Paste Your Statement of Purpose</div>
            <div className="field-row">
              <span className="field-label">Upload your SOP (PDF, Word, or .txt)</span>
              <div style={{ display: "flex", gap: 10, alignItems: "center", marginBottom: 10 }}>
                <button className="btn btn-sm" onClick={() => document.getElementById("sop-file-input").click()}>
                  📎 Upload file
                </button>
                <span style={{ fontSize: 12, color: "var(--text3)" }}>or paste below</span>
                <input id="sop-file-input" type="file" hidden accept=".pdf,.docx,.txt" onChange={handleSOPFileUpload} />
              </div>
              <span className="field-label">Your existing SOP</span>
              <textarea rows={12} value={existingSOP} onChange={e => setExistingSOP(e.target.value)}
                placeholder="Paste your full statement of purpose here..." />
            </div>
            {error && <div className="err">{error}</div>}
            <div className="actions-row">
              <button className="btn btn-primary" style={{ flex: 1 }}
                onClick={handleReview}
                disabled={loading || !existingSOP.trim() || !purpose}>
                {loading ? <><div className="spinner" />{loadingMsg}</> : "Submit for Review →"}
              </button>
            </div>
          </div>
        )}

        {/* Build mode — structured form */}
        {mode === "build" && (
          <div className="card">
            <div className="card-title">📝 Tell Us About Yourself</div>
            <p style={{ fontSize: 13, color: "var(--text3)", marginBottom: 20, lineHeight: 1.6 }}>
              The more specific you are, the more powerful your SOP. Only real information will be used — nothing is invented.
            </p>

            <div className="field-row">
              <span className="field-label">Your Name (optional)</span>
              <input value={formData.name} onChange={e => setFormData(f => ({ ...f, name: e.target.value }))} placeholder="e.g. Amara Osei" />
            </div>

            <div className="field-row">
              <span className="field-label">Home Country *</span>
              <select value={formData.country} onChange={e => setFormData(f => ({ ...f, country: e.target.value }))}>
                <option value="">Select your country...</option>
                {["Afghanistan", "Albania", "Algeria", "Andorra", "Angola", "Antigua and Barbuda", "Argentina", "Armenia", "Australia",
                  "Austria", "Azerbaijan", "Bahamas", "Bahrain", "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", "Benin",
                  "Bhutan", "Bolivia", "Bosnia and Herzegovina", "Botswana",
                  "Brazil", "Brunei", "Bulgaria", "Burkina Faso", "Burundi", "Cabo Verde", "Cambodia", "Cameroon", "Canada",
                  "Central African Republic", "Chad", "Chile", "China", "Colombia", "Comoros", "Congo", "Costa Rica",
                  "Croatia", "Cuba", "Cyprus", "Czech Republic", "Denmark", "Djibouti", "Dominica", "Dominican Republic",
                  "DR Congo", "Ecuador", "Egypt", "El Salvador", "Equatorial Guinea", "Eritrea", "Estonia", "Eswatini",
                  "Ethiopia", "Fiji", "Finland", "France", "Gabon", "Gambia", "Georgia", "Germany", "Ghana", "Greece", "Grenada",
                  "Guatemala", "Guinea", "Guinea-Bissau", "Guyana", "Haiti", "Honduras", "Hungary", "Iceland", "India", "Indonesia",
                  "Iran", "Iraq", "Ireland", "Israel", "Italy", "Jamaica", "Japan", "Jordan", "Kazakhstan", "Kenya", "Kiribati",
                  "Kuwait", "Kyrgyzstan", "Laos", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libya", "Liechtenstein", "Lithuania",
                  "Luxembourg", "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali", "Malta", "Marshall Islands", "Mauritania",
                  "Mauritius", "Mexico", "Micronesia", "Moldova", "Monaco", "Mongolia", "Montenegro", "Morocco", "Mozambique",
                  "Myanmar", "Namibia", "Nauru", "Nepal", "Netherlands", "New Zealand", "Nicaragua", "Niger", "Nigeria",
                  "North Korea", "North Macedonia", "Norway", "Oman", "Pakistan", "Palau", "Palestine", "Panama",
                  "Papua New Guinea", "Paraguay", "Peru", "Philippines", "Poland", "Portugal", "Qatar", "Romania", "Russia",
                  "Rwanda", "Saint Kitts and Nevis", "Saint Lucia", "Saint Vincent and the Grenadines", "Samoa", "San Marino",
                  "Sao Tome and Principe", "Saudi Arabia", "Senegal", "Serbia", "Seychelles", "Sierra Leone", "Singapore",
                  "Slovakia", "Slovenia", "Solomon Islands", "Somalia",
                  "South Africa", "South Korea", "South Sudan", "Spain", "Sri Lanka", "Sudan",

                  "Suriname", "Sweden", "Switzerland", "Syria", "Taiwan", "Tajikistan", "Tanzania",

                  "Thailand", "Timor-Leste", "Togo", "Tonga", "Trinidad and Tobago", "Tunisia",

                  "Turkey", "Turkmenistan", "Tuvalu", "Uganda", "Ukraine", "United Arab Emirates",

                  "United Kingdom", "United States", "Uruguay", "Uzbekistan", "Vanuatu", "Vatican City",

                  "Venezuela", "Vietnam", "Yemen", "Zambia", "Zimbabwe", "Other"

                ].map(c =>
                  <option key={c} value={c}>{c}</option>)}
              </select>
            </div>

            <div className="field-row">
              <span className="field-label">Country Challenge Being Addressed *</span>
              <textarea rows={4} value={formData.countryChallenge}
                onChange={e => setFormData(f => ({ ...f, countryChallenge: e.target.value }))}
                placeholder="What specific problem, gap, or need in your home country does this programme help you address? Name regions, sectors, communities, or systems where possible. Be specific — not 'poor healthcare' but 'maternal mortality in rural northern Nigeria due to lack of trained midwives'..." />
            </div>

            <div className="field-row">
              <span className="field-label">Academic Background *</span>
              <textarea rows={4} value={formData.academic}
                onChange={e => setFormData(f => ({ ...f, academic: e.target.value }))}
                placeholder="Your degrees, institutions, grades, academic honours, relevant coursework, thesis if any..." />
            </div>

            <div className="field-row">
              <span className="field-label">Work & Research Experience *</span>
              <textarea rows={4} value={formData.experience}
                onChange={e => setFormData(f => ({ ...f, experience: e.target.value }))}
                placeholder="Jobs, internships, research projects, publications, conferences, fieldwork..." />
            </div>

            <div className="field-row">
              <span className="field-label">Current Project or Ongoing Work</span>
              <textarea rows={4} value={formData.currentProject}
                onChange={e => setFormData(f => ({ ...f, currentProject: e.target.value }))}
                placeholder="Describe your current project in detail — what it does, what technology it uses, what stage it is at, and what specific gap you need this programme to close..." />
            </div>

            <div className="field-row">
              <span className="field-label">Key Achievements & Awards</span>
              <textarea rows={3} value={formData.achievements}
                onChange={e => setFormData(f => ({ ...f, achievements: e.target.value }))}
                placeholder="Awards, scholarships received, leadership roles, community impact, notable projects..." />
            </div>

            <div className="field-row">
              <span className="field-label">Why This School / Scholarship? *</span>
              <textarea rows={4} value={formData.whyTarget}
                onChange={e => setFormData(f => ({ ...f, whyTarget: e.target.value }))}
                placeholder="Specific professors, labs, programmes, values, alumni, mission that align with your goals..." />
            </div>

            <div className="field-row">
              <span className="field-label">Career Goals *</span>
              <textarea rows={3} value={formData.goals}
                onChange={e => setFormData(f => ({ ...f, goals: e.target.value }))}
                placeholder="What do you want to do in 5, 10 years? What problem are you solving? What change do you want to make?" />
            </div>

            <div className="field-row">
              <span className="field-label">Your Story & Motivation *</span>
              <textarea rows={5} value={formData.motivation}
                onChange={e => setFormData(f => ({ ...f, motivation: e.target.value }))}
                placeholder="The real reason you are pursuing this. A defining experience, a turning point, a person who shaped you. Be specific, be honest." />
            </div>

            <div className="field-grid">
              <div>
                <span className="field-label">Target Word Count (optional)</span>
                <input value={formData.targetLength} onChange={e => setFormData(f => ({ ...f, targetLength: e.target.value }))}
                  placeholder="e.g. 800 words, 2 pages..." />
              </div>
              <div>
                <span className="field-label">Anything Else to Include</span>
                <input value={formData.extraInfo} onChange={e => setFormData(f => ({ ...f, extraInfo: e.target.value }))}
                  placeholder="Gaps, challenges overcome, languages, special context..." />
              </div>
            </div>

            {error && <div className="err">{error}</div>}
            <div className="actions-row">
              <button className="btn btn-primary" style={{ flex: 1 }}
                onClick={handleBuild}
                disabled={loading || !purpose || !formData.academic || !formData.goals || !formData.motivation}>
                {loading ? <><div className="spinner" />{loadingMsg}</> : `${mode === "scratch" ? "Write My SOP" : "Build My SOP"} →`}
              </button>
            </div>
          </div>
        )}
        {/* Scratch mode — chat UI */}
        {mode === "scratch" && (
          <div className="card" style={{ padding: 0, overflow: "hidden" }}>
            <div style={{ padding: "16px 20px", borderBottom: "1px solid var(--border)", background: "var(--surface2)" }}>
              <div className="card-title" style={{ marginBottom: 0 }}>✍️ From Scratch</div>
            </div>
            {scratchMessages.length === 0 ? (
              <div style={{ padding: 32, textAlign: "center" }}>
                <p style={{ fontSize: 14, color: "var(--text2)", marginBottom: 20, lineHeight: 1.7 }}>
                  We'll build your SOP through a conversation. Answer honestly and specifically — I'll handle the writing.
                </p>
                <button className="btn btn-primary" onClick={startScratch}>Start the conversation →</button>
              </div>
            ) : (
              <>
                <div style={{ padding: "20px 20px 8px", maxHeight: 440, overflowY: "auto", display: "flex", flexDirection: "column", gap: 12 }}>
                  {scratchMessages.map((msg, i) => (
                    <div key={i} style={{
                      alignSelf: msg.role === "user" ? "flex-end" : "flex-start",
                      maxWidth: "82%",
                      background: msg.role === "user" ? "var(--accent)" : "var(--surface2)",
                      color: msg.role === "user" ? "#fff" : "var(--text)",
                      borderRadius: msg.role === "user" ? "16px 16px 4px 16px" : "16px 16px 16px 4px",
                      padding: "10px 14px",
                      fontSize: 13,
                      lineHeight: 1.6,
                      whiteSpace: "pre-wrap",
                    }}>
                      {msg.text}
                    </div>
                  ))}
                  {loading && (
                    <div style={{ alignSelf: "flex-start", display: "flex", gap: 4, padding: "10px 14px", background: "var(--surface2)", borderRadius: "16px 16px 16px 4px" }}>
                      {[0,1,2].map(i => (
                        <div key={i} style={{ width: 6, height: 6, borderRadius: "50%", background: "var(--text3)", animation: "wave 0.8s ease-in-out infinite alternate", animationDelay: `${i * 0.15}s` }} />
                      ))}
                    </div>
                  )}
                  <div ref={scratchEndRef} />
                </div>


                {scratchDone && (
                  <div style={{ padding: "12px 20px 16px", borderTop: "1px solid var(--border)", display: "flex", gap: 8, justifyContent: "flex-end" }}>
                    <button
                      className="btn"
                      disabled={loading}
                      onClick={() => {
                        setScratchDone(false);
                        const info = { ...scratchData, university: scratchData.whyTarget || "", scholarship: scratchData.purpose || "" };
                        setLoading(true);
                        setScratchMessages(prev => [...prev, { role: "ai", text: "Rewriting your SOP now..." }]);
                        callGroq(
                          "You are a ghostwriter writing a first-person Statement of Purpose. Write as if you ARE the applicant. Pure flowing prose. No bullet points. No headers. No banned phrases. If you catch yourself writing 'firsthand', 'witnessed', 'growing up', 'passionate', 'world-class', 'top-notch', 'cutting-edge', 'committed to', or 'driven by' — stop and rewrite that sentence. Start Block 1 immediately.",
                          SCRATCH_PROMPT(info),
                          "meta-llama/llama-4-scout-17b-16e-instruct",
                          0.3
                        ).then(raw => {
                          const text = raw.split("---WORD_COUNT---")[0].trim();
                          const wc = text.split(/\s+/).filter(Boolean).length;
                          setSopText(text);
                          setWordCount(wc);
                          setScreen("sop-result");
                        }).catch(e => {
                          setScratchMessages(prev => [...prev, { role: "ai", text: "Something went wrong: " + e.message + ". Try again." }]);
                        }).finally(() => {
                          setLoading(false);
                          setScratchDone(true);
                        });
                      }}
                    >
                      {loading ? "Writing..." : "↺ Regenerate SOP"}
                    </button>
                  </div>
                )}

                {!scratchDone && (
                  <div style={{ padding: "12px 20px 20px", borderTop: "1px solid var(--border)", display: "flex", gap: 8 }}>
                    <input
                      style={{ flex: 1, fontSize: 13 }}
                      placeholder={SCRATCH_QUESTIONS[scratchStep]?.placeholder || "Type your answer..."}
                      value={scratchInput}
                      onChange={e => setScratchInput(e.target.value)}
                      onKeyDown={e => e.key === "Enter" && !e.shiftKey && handleScratchSend()}
                      autoFocus
                    />
                    <button className="btn btn-primary" onClick={handleScratchSend} disabled={!scratchInput.trim() || loading}>
                      Send →
                    </button>
                  </div>
                )}
              </>
            )}
          </div>
        )}
      </div>
    </div>
  );
  if (screen === "review-result" && reviewResult) return (
    <div style={{ minHeight: "calc(100vh - 60px)", background: "var(--bg)" }}>
      <style>{STYLES}</style>
      <div className="sop-wrap">
        <div className="sop-header">
          <button className="btn btn-sm" style={{ marginBottom: 12 }} onClick={() => setScreen("home")}>← Home</button>
          <div className="sop-title">Committee <em>Review</em></div>
          <div className="sop-sub">{getUniversity() || getScholarship() || "SOP"} · {getField()}</div>
        </div>

        {/* Overall */}
        <div className="card">
          <div style={{ display: "flex", gap: 24, alignItems: "center", flexWrap: "wrap" }}>
            <div className="overall-score-ring" style={{ borderColor: scoreColor(reviewResult.overallScore), color: scoreColor(reviewResult.overallScore) }}>
              <div style={{ fontFamily: "'Fraunces', serif", fontSize: 28, fontWeight: 700, lineHeight: 1 }}>{reviewResult.overallScore}</div>
              <div style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: 9, letterSpacing: "0.1em", color: "var(--text3)", marginTop: 2 }}>/ 100</div>
            </div>
            <div style={{ flex: 1, minWidth: 200 }}>
              <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 10 }}>
                <span style={{ fontFamily: "'Fraunces', serif", fontSize: 17, fontWeight: 600 }}>Overall Verdict</span>
                {reviewResult.recommendation && (
                  <span className={`tag ${recommendationTag(reviewResult.recommendation)}`}>{reviewResult.recommendation}</span>
                )}
              </div>
              <p style={{ fontSize: 14, color: "var(--text2)", lineHeight: 1.75 }}>{reviewResult.overallVerdict}</p>
            </div>
          </div>
        </div>

        {/* Section scores */}
        <div className="card">
          <div className="card-title">Section Scores</div>
          {(reviewResult.sections || []).map((sec, i) => (
            <div key={i} className="section-score">
              <div className="section-score-header">
                <span className="section-score-name">{sec.name}</span>
                <span className="section-score-num" style={{ color: scoreColor(sec.score) }}>{sec.score}<span style={{ fontSize: 11, color: "var(--text3)" }}>/100</span></span>
              </div>
              <div className="score-bar-bg">
                <div className="score-bar-fill" style={{ width: `${sec.score}%`, background: scoreColor(sec.score) }} />
              </div>
              {sec.quote && <div className="section-quote">"{sec.quote}"</div>}
              <div className="section-feedback">{sec.feedback}</div>
              {sec.suggestion && <div className="section-suggestion">💡 {sec.suggestion}</div>}
            </div>
          ))}
        </div>

        {/* Strengths & Weaknesses */}
        <div className="card">
          <div className="card-title">Strengths</div>
          {(reviewResult.strengths || []).map((s, i) => (
            <div key={i} style={{ display: "flex", gap: 10, alignItems: "flex-start", marginBottom: 8 }}>
              <span style={{ color: "var(--success)", flexShrink: 0, marginTop: 2 }}>✓</span>
              <span style={{ fontSize: 13, color: "var(--text2)", lineHeight: 1.6 }}>{s}</span>
            </div>
          ))}
        </div>

        <div className="card">
          <div className="card-title" style={{ color: "var(--danger)" }}>Critical Weaknesses</div>
          {(reviewResult.critical_weaknesses || []).map((w, i) => (
            <div key={i} style={{ display: "flex", gap: 10, alignItems: "flex-start", marginBottom: 8 }}>
              <span style={{ color: "var(--danger)", flexShrink: 0, marginTop: 2 }}>✗</span>
              <span style={{ fontSize: 13, color: "var(--text2)", lineHeight: 1.6 }}>{w}</span>
            </div>
          ))}
          {(reviewResult.red_flags || []).length > 0 && (
            <>
              <div className="divider" />
              <div style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: 10, color: "var(--danger)", textTransform: "uppercase", letterSpacing: "0.1em", marginBottom: 10 }}>🚩 Red Flags</div>
              {reviewResult.red_flags.map((f, i) => (
                <div key={i} style={{ display: "flex", gap: 10, alignItems: "flex-start", marginBottom: 8 }}>
                  <span style={{ color: "var(--danger)", flexShrink: 0 }}>!</span>
                  <span style={{ fontSize: 13, color: "var(--danger)", lineHeight: 1.6 }}>{f}</span>
                </div>
              ))}
            </>
          )}
        </div>

        <div className="card">
          <div className="card-title">Rewrite Priorities</div>
          {(reviewResult.rewrite_priorities || []).map((p, i) => (
            <div key={i} style={{ display: "flex", gap: 12, alignItems: "flex-start", marginBottom: 10 }}>
              <div style={{ width: 22, height: 22, borderRadius: "50%", background: "var(--accent-bg)", border: "1px solid var(--accent-border)", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                <span style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: 10, color: "var(--accent)" }}>{i + 1}</span>
              </div>
              <span style={{ fontSize: 13, color: "var(--text2)", lineHeight: 1.6 }}>{p}</span>
            </div>
          ))}
        </div>

        <div className="actions-row">
          <button className="btn btn-primary" onClick={() => { setMode("build"); setScreen("setup"); }}>Build a Better SOP →</button>
          <button className="btn" onClick={() => setScreen("home")}>← Home</button>
        </div>
      </div>
    </div>
  );

  // ── SOP RESULT ──
  if (screen === "sop-result") return (
    <div style={{ minHeight: "calc(100vh - 60px)", background: "var(--bg)" }}>
      <style>{STYLES}</style>
      <div className="sop-wrap">
        <div className="sop-header">
          <button className="btn btn-sm" style={{ marginBottom: 12 }} onClick={() => setScreen("home")}>← Home</button>
          <div className="sop-title">Your <em>Statement of Purpose</em></div>
          <div style={{ display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap", marginTop: 8 }}>
            {getUniversity() && <span className="tag tag-neutral">{getUniversity()}</span>}
            {getScholarship() && <span className="tag tag-neutral">{getScholarship()}</span>}
            <span className="tag tag-neutral">{wordCount} words</span>
          </div>
        </div>

        <div style={{ display: "flex", gap: 10, marginBottom: 16, flexWrap: "wrap" }}>
          <button className="btn btn-sm" onClick={() => setIsEditing(e => !e)}
            style={isEditing ? { background: "var(--accent-bg)", color: "var(--accent)", borderColor: "var(--accent-border)" } : {}}>
            {isEditing ? "✓ Preview" : "✏ Edit"}
          </button>
          <button className="btn btn-sm btn-gold" onClick={exportPDF}>
            ↓ Export PDF
          </button>
          <button className="btn btn-sm btn-gold" onClick={exportWord}>
            ↓ Export Word (.docx)
          </button>
          <button className="btn btn-sm" onClick={() => navigator.clipboard.writeText(sopText)}>
            Copy
          </button>
          <button className="btn btn-sm" onClick={() => { setMode("review"); setExistingSOP(sopText); setScreen("setup"); }}>
            🔍 Review this SOP
          </button>
        </div>

        {isEditing ? (
          <textarea
            className="sop-editable"
            value={sopText}
            onChange={e => { setSopText(e.target.value); setWordCount(e.target.value.split(/\s+/).filter(Boolean).length); }}
          />
        ) : (
          <div className="sop-output">{sopText}</div>
        )}

        <div className="actions-row" style={{ marginTop: 20 }}>
          <button className="btn btn-primary" onClick={() => { setScreen("setup"); }}>Regenerate →</button>
          <button className="btn" onClick={() => setScreen("home")}>← Home</button>
        </div>
      </div>
    </div>
  );

  // ── HISTORY SCREEN ──
  if (screen === "history") return (
    <div style={{ minHeight: "calc(100vh - 60px)", background: "var(--bg)" }}>
      <style>{STYLES}</style>
      <div className="sop-wrap">
        <div className="sop-header">
          <button className="btn btn-sm" style={{ marginBottom: 12 }} onClick={() => setScreen("home")}>← Back</button>
          <div className="sop-title">Session <em>History</em></div>
          <div className="sop-sub">All sessions stored locally on your device.</div>
        </div>
        <div className="card" style={{ padding: 0, overflow: "hidden" }}>
          {history.length === 0 ? (
            <div style={{ padding: 40, textAlign: "center", color: "var(--text3)", fontSize: 14 }}>No sessions yet.</div>
          ) : history.map((item, i) => (
            <div key={i} className="history-item" onClick={() => loadHistoryItem(item)}>
              <div style={{ width: 36, height: 36, borderRadius: 8, background: "var(--accent-bg)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 18, flexShrink: 0 }}>
                {item.mode === "review" ? "🔍" : item.mode === "scratch" ? "✍️" : "🏗"}
              </div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: 14, fontWeight: 500 }}>{item.title}</div>
                <div style={{ fontSize: 12, color: "var(--text3)", marginTop: 2 }}>{item.subtitle}</div>
              </div>
              <div style={{ fontSize: 11, color: "var(--text3)", flexShrink: 0 }}>{timeAgo(item.ts)}</div>
            </div>
          ))}
        </div>
        {history.length > 0 && (
          <button className="btn btn-danger btn-sm" style={{ marginTop: 12 }} onClick={() => { localStorage.removeItem("lliuq_sop_history"); setHistory([]); }}>
            Clear all history
          </button>
        )}
      </div>
    </div>
  );

  return null;
}